import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ErrorText } from "../../../../components/billing";
import { Button } from "../../../../components/button";
import { Icon } from "../../../../components/icons";
import { Loader } from "../../../../components/loader";
import { BillingDTO } from "../../../../store/billing/models/dto";
import { Billing } from "../../../../store/billing/reducer";
import { useFetchable } from "../../../../store/common/fetchable";
import { UsersDTO } from "../../../../store/users/models/dto";
import { Users } from "../../../../store/users/reducer";
import { useBrowserWallet } from "../../../../store/wallets/crypto";
import { usePurchase } from "./purchase-hook";

type FormProps = {
  chain: BillingDTO.Responses.GetSKRTAddresses.T[number];
  amount: number;
};

export const Metamask: FC<FormProps> = (props) => {
  const forexRate = useFetchable(Billing.forexRate);
  const currentUser = useFetchable(Users.current);
  return (
    <Loader<
      BillingDTO.Responses.GetForexRate.T | UsersDTO.Responses.GetSingle.T
    >
      data={[forexRate, currentUser]}
    >
      {([loadedRate, loadedUser]) => (
        <InnerMetmask
          {...props}
          rate={(loadedRate as BillingDTO.Responses.GetForexRate.T).rate}
          kycStatus={(loadedUser as UsersDTO.Responses.GetSingle.T).kycStatus}
        />
      )}
    </Loader>
  );
};

export const InnerMetmask: FC<
  FormProps &
    BillingDTO.Responses.GetForexRate.T &
    Pick<UsersDTO.Responses.GetSingle.T, "kycStatus">
> = ({ amount, chain, rate, kycStatus }) => {
  const { isVerified } = useBrowserWallet();
  const { t } = useTranslation("billing");
  const onSubmit = usePurchase(amount, amount * rate, chain);

  return (
    <>
      <Button
        onClick={onSubmit}
        disabled={
          !isVerified || chain === undefined || kycStatus !== "VERIFIED"
        }
      >
        {t("open-metamask")}&nbsp; <Icon type="metamaskLogo" />
      </Button>
      {kycStatus !== "VERIFIED" ? (
        <ErrorText>
          {t("you-must-verify-yourself-to-purchase-credits")}
        </ErrorText>
      ) : !isVerified ? (
        <ErrorText>{t("your-wallet-must-be-connected-and-verified")}</ErrorText>
      ) : null}
    </>
  );
};
